import React, { createContext, useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthAlertDialog from "Components/Shared/AuthAlertDialog";
import { isTokenValidate, extractTokenDetails } from "Helpers/ats.helper";
import { publicPaths, Paths } from "Router/Paths";
import { SUPER_ADMIN, ASSOCIATE_BUYER_SLUG } from "Static/utils/commonUtils";

const UserContext = createContext();

// User context
const useUserContext = () => {
  return useContext(UserContext);
};

// Context provider wrapper
const UserContextProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [role, setRole] = useState("");
  const [userDetails, setuserDetails] = useState(null);
  const [permission, setPermission] = useState(null);
  const [isAuthErr, setAuthErr] = useState(false);
  const [profile, setProfile] = React.useState(null);
  const [notificationCount, setNotificatonCount] = React.useState();

  const navigate = useNavigate();
  const location = useLocation();
  let authorization;

  /**
   * handle role based redirection
   */
  const roleBasedRedirect = (auth) => {
    // if (isTokenValidate(auth)) {
    if (isTokenValidate(auth)) {
      const { role_slug } = extractTokenDetails(auth);

      let role =
        role_slug === SUPER_ADMIN
          ? role_slug
          : role_slug === ASSOCIATE_BUYER_SLUG
            ? role_slug
            : "User";
      switch (role) {
        case SUPER_ADMIN:
          if (
            location.pathname === "/admin" ||
            location.pathname === "/admin/" ||
            location.pathname === "/" || 
            location.pathname === "/login"||
            location.pathname === "/forgot-password"
          )
            navigate(Paths.home, { replace: true });
          break;
        case ASSOCIATE_BUYER_SLUG:
          if (
            location.pathname === "/admin" ||
            location.pathname === "/admin/" ||
            location.pathname === "/" || 
            location.pathname === "/login"||
            location.pathname === "/forgot-password"
          )
            navigate(Paths.userDashboard, { replace: true });
          break;
        case "User":
          if (
            location.pathname === "/admin" ||
            location.pathname === "/admin/" ||
            location.pathname === "/" ||
            location.pathname === "/login" ||
            location.pathname === "/forgot-password"
          )
            navigate(Paths.home, { replace: true });
          break;
        case "INVESTOR":
          if (location.pathname === "/admin") navigate("/", { replace: true });
          break;
        case "DEALER":
          if (location.pathname === "/admin") navigate("/", { replace: true });
          break;
      }
    } else {
      // handled logged out user
      if (
        location.pathname != "/admin" &&
        location.pathname?.startsWith("/admin") &&
        !isTokenValidate(authorization)
      ) {
        localStorage.removeItem("User");
        authorization = null;
        setLoggedIn(false);

        navigate(Paths.login);
      }
    }
  };

  /**
   * handle role based routing
   */
  useEffect(() => {
    const auth = localStorage.getItem("User");
    roleBasedRedirect(auth);
  }, [location]);

  useEffect(() => {
    if (location.pathname === "/pucform") {
      localStorage.setItem("role", "PUC");
      setRole("PUC");
    }
    // if (location.pathname === "/" || location.pathname === "/admin") {
    //   localStorage.setItem("role", "");
    //   setRole("");
    //   localStorage.setItem("LoggedIn", false);
    // }

    const auth = localStorage.getItem("User");
    // Get new token from URL
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (auth && auth !== "null" && isTokenValidate(auth) && !urlParams.get("token")) {
      authorization = auth;
      setLoggedIn(true);

      setuserDetails(extractTokenDetails(auth));
      roleBasedRedirect(auth);
    } else {
      authorization = urlParams.get("token");

      const isPublicPath = publicPaths.includes(location.pathname.split("/")[1]);

      if (!isPublicPath) {
        if (!authorization) {
          localStorage.removeItem("User");
        } else {
          if (isTokenValidate(authorization)) {
            setAuthToken(authorization);
            localStorage.setItem("User", authorization);
            localStorage.setItem("role", "ADMIN");
            setRole("ADMIN");
            localStorage.setItem("LoggedIn", true);
            setuserDetails(extractTokenDetails(authorization));
            setLoggedIn(true);
            window.location.href = "/";
          } else {
            setAuthErr(true);
            localStorage.removeItem("User");
            authorization = null;
          }
        }
      }
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        userDetails,
        authToken,
        permission,
        loggedIn,
        role,
        setLoggedIn,
        setuserDetails,
        setPermission,
        profile,
        setProfile,
        setAuthErr,
        setRole,
        notificationCount,
        setNotificatonCount
      }}>
      {isAuthErr ? <AuthAlertDialog /> : null}
      {children}
    </UserContext.Provider>
  );
};

export { useUserContext, UserContextProvider };
